import { getTopFiveLeagues } from "../../js/api/topfiveleague.js";
import { getTopTenMatchGames } from "../../js/api/toptenprematchgames.js";
import { getTopTenLiveGames } from "../../js/api/toptenlivegames.js";
import { sports } from "../components/Leftpanel.js";
import { getTopTenLiveTemplate } from "../templates/top-ten-live-games.js";
import {
  getFeaturedMatches,
  getTodayMatches,
} from "../../js/api/featuredPreMatch.js";
import { getPrematchGamesMainLeague } from "../../js/api/mainLeagueMatch.js";
import { getJackPotValue } from "../../js/api/jackpot.js";
import { getLiveTemplate } from "../templates/live-games.js";
import { _t } from "../../services/TranslationService.js";
import { findTeamKit } from "../../services/TeamKitService.js";

let timers = [];
let Landing = {
  render: async () => {
    const blockedSports = JSON.parse(localStorage.getItem('blockedSports') ?? '[]');
    const sport_id = 1;
    const blockedFootball = blockedSports.indexOf(sport_id.toString()) !== -1;

    let featuredPrematchs = blockedFootball ? [] : await getFeaturedMatches(sport_id);

    let jackpotvalue = await getJackPotValue();
    let featuredPrematchView = "";
    let todayMatchesView = "";
    let next2hMatchesView = "";
    let next4hMatchesView = "";
    let mainLeagueMatches = null; //await getPrematchGamesMainLeague();
    let todayMatches = blockedFootball ? [] : (await getTodayMatches()).map((m) => {
      m["whole_date_timestamp"] = new Date(m.whole_date).getTime();
      return m;
    });
    const now = new Date().getTime();
    const next2hTimestamp = now + 2 * 60 * 60 * 1000;
    const next4hTimestamp = now + 4 * 60 * 60 * 1000;
    const next2hMatches = todayMatches.filter(
      (match) =>
        match.whole_date_timestamp > now &&
        match.whole_date_timestamp < next2hTimestamp
    );
    const next4hMatches = todayMatches.filter(
      (match) =>
        match.whole_date_timestamp > now &&
        match.whole_date_timestamp < next4hTimestamp
    );

    // console.log('next 2h matches', next2hMatches);
    // console.log('next 4h matches', next4hMatches);

    let mainLeagueMatchesView = "";

    let mainLeagueName =
      mainLeagueMatches && mainLeagueMatches[0]
        ? mainLeagueMatches[0].league
        : "";

    if (featuredPrematchs) {
      featuredPrematchs.forEach((featuredPrematch) => {
        if (featuredPrematch.odd) {
          const date = new Date(featuredPrematch.game_date);
          let dd = String(date.getDate()).padStart(2, "0");
          let mm = String(date.getMonth() + 1).padStart(2, "0"); //January is 0!
          let yyyy = date.getFullYear();

          const time = `${featuredPrematch.game_time.split(":")[0]}:${
            featuredPrematch.game_time.split(":")[1]
          }`;
          featuredPrematchView =
            featuredPrematchView +
            `<div class="featuredPrematchItem">
             <a href="#/Match/${featuredPrematch.id}" class="featuredMatchName">
                <span>
                  <span class="kfm-Competitor_TeamKit">
                    <object data="${
                      window.location.pathname
                    }img/kit-black.svg?v=2" type="image/svg">
                      <img class="ml-TeamKit_SVG" alt="${
                        featuredPrematch.home_team
                      }" src="${findTeamKit(
              featuredPrematch.home_team
            )}" lazy onerror="this.src='${
              window.location.pathname
            }img/kit-black.svg?v=2'" />
                    </object>
                  </span>
                  ${featuredPrematch.home_team}
                </span>
                <span>
                  <span class="kfm-Competitor_TeamKit">
                    <object data="${
                      window.location.pathname
                    }img/kit-yellow.svg?v=2" type="image/svg">
                      <img class="ml-TeamKit_SVG" alt="${
                        featuredPrematch.away_team
                      }" src="${findTeamKit(
              featuredPrematch.away_team
            )}" lazy onerror="this.src='${
              window.location.pathname
            }img/kit-yellow.svg?v=2'" />
                    </object>
                  </span>
                  ${featuredPrematch.away_team}
                </span>
              </a>
              <span class="featurePreMatchDate">${dd}/${mm} ${time}</span>
                      <span class="numberofmarkets">${
                        featuredPrematch.count_options
                      } ></span>
              <div class="featuredMatchBtn">
                   <div class="singleHomeOdd bettingBtn ${
                     Math.floor(
                       (parseFloat(
                         featuredPrematch.odd.split(",")[0].split("|")[1]
                       ) +
                         Number.EPSILON) *
                         100
                     ) /
                       100 ==
                     1
                       ? "disabledBtn"
                       : ""
                   } ${
              featuredPrematch.odd.split(",")[0].split("|")[0]
            }" match-odd="${(
              Math.floor(
                (parseFloat(featuredPrematch.odd.split(",")[0].split("|")[1]) +
                  Number.EPSILON) *
                  100
              ) / 100
            ).toFixed(2)}" match-home-name="${
              featuredPrematch.home_team
            }" match-away-name="${featuredPrematch.away_team}" match-market="${
              ["1", "X", "2"].includes(
                featuredPrematch.odd.split(",")[0].split("|")[2]
              )
                ? "Rezultat final"
                : featuredPrematch.odd.split(",")[0].split("|")[2]
            }" coef-id="${
              featuredPrematch.odd.split(",")[0].split("|")[0]
            }" match-market-option="1 " bet-id="${
              featuredPrematch.odd.split(",")[0].split("|")[0]
            }" game-id="${featuredPrematch.id}"><i>1</i><i>${(
              Math.floor(
                (parseFloat(featuredPrematch.odd.split(",")[0].split("|")[1]) +
                  Number.EPSILON) *
                  100
              ) / 100
            ).toFixed(2)}</i></div>
                   <div class="singleDrawOdd bettingBtn ${
                     Math.floor(
                       (parseFloat(
                         featuredPrematch.odd.split(",")[1].split("|")[1]
                       ) +
                         Number.EPSILON) *
                         100
                     ) /
                       100 ==
                     1
                       ? "disabledBtn"
                       : ""
                   } ${
              featuredPrematch.odd.split(",")[1].split("|")[0]
            }" match-odd="${(
              Math.floor(
                (parseFloat(featuredPrematch.odd.split(",")[1].split("|")[1]) +
                  Number.EPSILON) *
                  100
              ) / 100
            ).toFixed(2)}" match-home-name="${
              featuredPrematch.home_team
            }" match-away-name="${featuredPrematch.away_team}" match-market="${
              ["1", "X", "2"].includes(
                featuredPrematch.odd.split(",")[1].split("|")[2]
              )
                ? "Rezultat final"
                : featuredPrematch.odd.split(",")[1].split("|")[2]
            }" coef-id="${
              featuredPrematch.odd.split(",")[1].split("|")[0]
            }" match-market-option="X " bet-id="${
              featuredPrematch.odd.split(",")[1].split("|")[0]
            }" game-id="${featuredPrematch.id}"><i>X</i><i>${(
              Math.floor(
                (parseFloat(featuredPrematch.odd.split(",")[1].split("|")[1]) +
                  Number.EPSILON) *
                  100
              ) / 100
            ).toFixed(2)}</i></div>
                   <div class="singleAwayOdd bettingBtn ${
                     Math.floor(
                       (parseFloat(
                         featuredPrematch.odd.split(",")[2].split("|")[1]
                       ) +
                         Number.EPSILON) *
                         100
                     ) /
                       100 ==
                     1
                       ? "disabledBtn"
                       : ""
                   } ${
              featuredPrematch.odd.split(",")[2].split("|")[0]
            }" match-odd="${(
              Math.floor(
                (parseFloat(featuredPrematch.odd.split(",")[2].split("|")[1]) +
                  Number.EPSILON) *
                  100
              ) / 100
            ).toFixed(2)}" match-home-name="${
              featuredPrematch.home_team
            }" match-away-name="${featuredPrematch.away_team}" match-market="${
              ["1", "X", "2"].includes(
                featuredPrematch.odd.split(",")[2].split("|")[2]
              )
                ? "Rezultat final"
                : featuredPrematch.odd.split(",")[2].split("|")[2]
            }" coef-id="${
              featuredPrematch.odd.split(",")[2].split("|")[0]
            }" match-market-option="2 " bet-id="${
              featuredPrematch.odd.split(",")[2].split("|")[0]
            }" game-id="${featuredPrematch.id}"><i>2</i><i>${(
              Math.floor(
                (parseFloat(featuredPrematch.odd.split(",")[2].split("|")[1]) +
                  Number.EPSILON) *
                  100
              ) / 100
            ).toFixed(2)}</i></div>
              </div>
        </div>`;
        }
      });
    }

    const generateMatchesView = (matches) => {
      let matchesView = "";

      if (!matches || (matches && matches.length === 0))
        return `<p style="color: white; font-size: 12px; padding: 15px;">${_t(
          "Nuk ka ndeshje te planifikuara per kete periudhe kohore"
        )}</p>`;

      const uniqueLeaguesTodayMatches = [
        ...new Set(matches.map((item) => item.league_id)),
      ];

      uniqueLeaguesTodayMatches.forEach((leagueId) => {
        let singleDateView = "";
        let leagueName = "";

        matches
          .filter((a) => a.league_id === leagueId)
          .map((todayMatch) => {
            leagueName = todayMatch.league;

            if (todayMatch.odd) {
              const date = new Date(todayMatch.game_date);
              let dd = String(date.getDate()).padStart(2, "0");
              let mm = String(date.getMonth() + 1).padStart(2, "0"); //January is 0!
              let yyyy = date.getFullYear();

              const time = `${todayMatch.game_time.split(":")[0]}:${
                todayMatch.game_time.split(":")[1]
              }`;
              try {
                singleDateView =
                  singleDateView +
                  `
                  <div class="featuredPrematchItem">
                    <div class="helperLeftContentMatch">
                      <a href="#/Match/${
                        todayMatch.id
                      }?today=1" class="featuredMatchName">
                        <span>${todayMatch.home_team}</span>
                        <span>${todayMatch.away_team}</span>
                      </a>
                      <span class="featurePreMatchDate">${dd}/${mm} ${time}</span>
                      <span class="numberofmarkets">${
                        todayMatch.count_options
                      } ></span>
                    </div>
                    <div class="featuredMatchBtn">
                      <div class="singleHomeOdd bettingBtn ${
                        Math.floor(
                          (parseFloat(
                            todayMatch.odd.split(",")[0].split("|")[1]
                          ) +
                            Number.EPSILON) *
                            100
                        ) /
                          100 ==
                        1
                          ? "disabledBtn"
                          : ""
                      } ${
                    todayMatch.odd.split(",")[0].split("|")[0]
                  }" match-odd="${(
                    Math.floor(
                      (parseFloat(todayMatch.odd.split(",")[0].split("|")[1]) +
                        Number.EPSILON) *
                        100
                    ) / 100
                  ).toFixed(2)}" match-home-name="${
                    todayMatch.home_team
                  }" match-away-name="${todayMatch.away_team}" match-market="${
                    ["1", "X", "2"].includes(
                      todayMatch.odd.split(",")[0].split("|")[2]
                    )
                      ? "Rezultat final"
                      : todayMatch.odd.split(",")[0].split("|")[2]
                  }"  match-market-option="1 " coef-id="${
                    todayMatch.odd.split(",")[0].split("|")[0]
                  }" bet-id="${
                    todayMatch.odd.split(",")[0].split("|")[0]
                  }" game-id="${todayMatch.id}"><i>1</i><i>${(
                    Math.floor(
                      (parseFloat(todayMatch.odd.split(",")[0].split("|")[1]) +
                        Number.EPSILON) *
                        100
                    ) / 100
                  ).toFixed(2)}</i></div>
                      <div class="singleDrawOdd bettingBtn ${
                        Math.floor(
                          (parseFloat(
                            todayMatch.odd.split(",")[1].split("|")[1]
                          ) +
                            Number.EPSILON) *
                            100
                        ) /
                          100 ==
                        1
                          ? "disabledBtn"
                          : ""
                      } ${
                    todayMatch.odd.split(",")[1].split("|")[0]
                  }" match-odd="${(
                    Math.floor(
                      (parseFloat(todayMatch.odd.split(",")[1].split("|")[1]) +
                        Number.EPSILON) *
                        100
                    ) / 100
                  ).toFixed(2)}" match-home-name="${
                    todayMatch.home_team
                  }" match-away-name="${todayMatch.away_team}" match-market="${
                    ["1", "X", "2"].includes(
                      todayMatch.odd.split(",")[1].split("|")[2]
                    )
                      ? "Rezultat final"
                      : todayMatch.odd.split(",")[1].split("|")[2]
                  }"  match-market-option="X " coef-id="${
                    todayMatch.odd.split(",")[1].split("|")[0]
                  }" bet-id="${
                    todayMatch.odd.split(",")[1].split("|")[0]
                  }" game-id="${todayMatch.id}"><i>X</i><i>${(
                    Math.floor(
                      (parseFloat(todayMatch.odd.split(",")[1].split("|")[1]) +
                        Number.EPSILON) *
                        100
                    ) / 100
                  ).toFixed(2)}</i></div>
                      <div class="singleAwayOdd bettingBtn ${
                        Math.floor(
                          (parseFloat(
                            todayMatch.odd.split(",")[2].split("|")[1]
                          ) +
                            Number.EPSILON) *
                            100
                        ) /
                          100 ==
                        1
                          ? "disabledBtn"
                          : ""
                      } ${
                    todayMatch.odd.split(",")[2].split("|")[0]
                  }" match-odd="${(
                    Math.floor(
                      (parseFloat(todayMatch.odd.split(",")[2].split("|")[1]) +
                        Number.EPSILON) *
                        100
                    ) / 100
                  ).toFixed(2)}" match-home-name="${
                    todayMatch.home_team
                  }" match-away-name="${todayMatch.away_team}" match-market="${
                    ["1", "X", "2"].includes(
                      todayMatch.odd.split(",")[2].split("|")[2]
                    )
                      ? "Rezultat final"
                      : todayMatch.odd.split(",")[2].split("|")[2]
                  }"  match-market-option="2 " coef-id="${
                    todayMatch.odd.split(",")[2].split("|")[0]
                  }" bet-id="${
                    todayMatch.odd.split(",")[2].split("|")[0]
                  }" game-id="${todayMatch.id}"><i>2</i><i>${(
                    Math.floor(
                      (parseFloat(todayMatch.odd.split(",")[2].split("|")[1]) +
                        Number.EPSILON) *
                        100
                    ) / 100
                  ).toFixed(2)}</i></div>
                    </div>
                  </div>`;
              } catch {}
            }
          });
        matchesView += `
          <div class="singleHeaderHolderLabel fourColumn">
          <div class="singleHeaderLabel">${leagueName}</div>
          <div class="singleHeaderLabel">1</div>
          <div class="singleHeaderLabel">x</div>
          <div class="singleHeaderLabel">2</div>
        </div>${singleDateView}`;
      });
      return matchesView;
    };

    todayMatchesView = generateMatchesView(todayMatches);
    next2hMatchesView = generateMatchesView(next2hMatches);
    next4hMatchesView = generateMatchesView(next4hMatches);

    if (mainLeagueMatches) {
      mainLeagueMatches.forEach((mainLeagueMatche) => {
        if (mainLeagueMatche.odd) {
          const date = new Date(mainLeagueMatche.game_date);
          let dd = String(date.getDate()).padStart(2, "0");
          let mm = String(date.getMonth() + 1).padStart(2, "0"); //January is 0!
          let yyyy = date.getFullYear();

          const time = `${mainLeagueMatche.game_time.split(":")[0]}:${
            mainLeagueMatche.game_time.split(":")[1]
          }`;
          mainLeagueMatchesView =
            mainLeagueMatchesView +
            `<div class="featuredPrematchItem">
                <a href="#/Match/${
                  mainLeagueMatche.id
                }" class="featuredMatchName">
                  <span>
                    <span class="kfm-Competitor_TeamKit">
                      <object data="${
                        window.location.pathname
                      }img/kit-black.svg?v=2" type="image/svg">
                        <img class="ml-TeamKit_SVG" src="${
                          window.location.pathname
                        }img/kit-black.svg?v=2" />
                      </object>
                    </span>
                    ${mainLeagueMatche.home_team}
                  </span>
                  <span>
                    <span class="kfm-Competitor_TeamKit">
                      <object data="${
                        window.location.pathname
                      }img/kit-yellow.svg?v=2" type="image/svg">
                        <img class="ml-TeamKit_SVG" src="${
                          window.location.pathname
                        }img/kit-yellow.svg?v=2" />
                      </object>
                    </span>
                    ${mainLeagueMatche.away_team}
                  </span>
                </a>
                <span class="featurePreMatchDate">${dd}/${mm} ${time}</span>
                        <span class="numberofmarkets">${
                          mainLeagueMatche.count_options
                        } ></span>
                <div class="featuredMatchBtn">
                     <div class="singleHomeOdd bettingBtn ${
                       Math.floor(
                         (parseFloat(
                           mainLeagueMatche.odd.split(",")[0].split("|")[1]
                         ) +
                           Number.EPSILON) *
                           100
                       ) /
                         100 ==
                       1
                         ? "disabledBtn"
                         : ""
                     } ${
              mainLeagueMatche.odd.split(",")[0].split("|")[0]
            }" match-odd="${(
              Math.floor(
                (parseFloat(mainLeagueMatche.odd.split(",")[0].split("|")[1]) +
                  Number.EPSILON) *
                  100
              ) / 100
            ).toFixed(2)}" match-home-name="${
              mainLeagueMatche.home_team
            }" match-away-name="${mainLeagueMatche.away_team}" match-market="${
              ["1", "X", "2"].includes(
                mainLeagueMatche.odd.split(",")[0].split("|")[2]
              )
                ? "Rezultat final"
                : mainLeagueMatche.odd.split(",")[0].split("|")[2]
            }"  match-market-option="1 " coef-id="${
              mainLeagueMatche.odd.split(",")[0].split("|")[0]
            }" bet-id="${
              mainLeagueMatche.odd.split(",")[0].split("|")[0]
            }" game-id="${mainLeagueMatche.id}"><i>1</i><i>${(
              Math.floor(
                (parseFloat(mainLeagueMatche.odd.split(",")[0].split("|")[1]) +
                  Number.EPSILON) *
                  100
              ) / 100
            ).toFixed(2)}</i></div>
                     <div class="singleDrawOdd bettingBtn ${
                       Math.floor(
                         (parseFloat(
                           mainLeagueMatche.odd.split(",")[1].split("|")[1]
                         ) +
                           Number.EPSILON) *
                           100
                       ) /
                         100 ==
                       1
                         ? "disabledBtn"
                         : ""
                     } ${
              mainLeagueMatche.odd.split(",")[1].split("|")[0]
            }" match-odd="${(
              Math.floor(
                (parseFloat(mainLeagueMatche.odd.split(",")[1].split("|")[1]) +
                  Number.EPSILON) *
                  100
              ) / 100
            ).toFixed(2)}" match-home-name="${
              mainLeagueMatche.home_team
            }" match-away-name="${mainLeagueMatche.away_team}" match-market="${
              ["1", "X", "2"].includes(
                mainLeagueMatche.odd.split(",")[1].split("|")[2]
              )
                ? "Rezultat final"
                : mainLeagueMatche.odd.split(",")[1].split("|")[2]
            }"  match-market-option="X " coef-id="${
              mainLeagueMatche.odd.split(",")[1].split("|")[0]
            }" bet-id="${
              mainLeagueMatche.odd.split(",")[1].split("|")[0]
            }" game-id="${mainLeagueMatche.id}"><i>X</i><i>${(
              Math.floor(
                (parseFloat(mainLeagueMatche.odd.split(",")[1].split("|")[1]) +
                  Number.EPSILON) *
                  100
              ) / 100
            ).toFixed(2)}</i></div>
                     <div class="singleAwayOdd bettingBtn ${
                       Math.floor(
                         (parseFloat(
                           mainLeagueMatche.odd.split(",")[2].split("|")[1]
                         ) +
                           Number.EPSILON) *
                           100
                       ) /
                         100 ==
                       1
                         ? "disabledBtn"
                         : ""
                     } ${
              mainLeagueMatche.odd.split(",")[2].split("|")[0]
            }" match-odd="${(
              Math.floor(
                (parseFloat(mainLeagueMatche.odd.split(",")[2].split("|")[1]) +
                  Number.EPSILON) *
                  100
              ) / 100
            ).toFixed(2)}" match-home-name="${
              mainLeagueMatche.home_team
            }" match-away-name="${mainLeagueMatche.away_team}" match-market="${
              ["1", "X", "2"].includes(
                mainLeagueMatche.odd.split(",")[2].split("|")[2]
              )
                ? "Rezultat final"
                : mainLeagueMatche.odd.split(",")[2].split("|")[2]
            }"  match-market-option="2 " coef-id="${
              mainLeagueMatche.odd.split(",")[2].split("|")[0]
            }" bet-id="${
              mainLeagueMatche.odd.split(",")[2].split("|")[0]
            }" game-id="${mainLeagueMatche.id}"><i>2</i><i>${(
              Math.floor(
                (parseFloat(mainLeagueMatche.odd.split(",")[2].split("|")[1]) +
                  Number.EPSILON) *
                  100
              ) / 100
            ).toFixed(2)}</i></div>
                </div>
          </div>`;
        }
      });
    }

    let sportsView = "";
    if (sports) {
      sports.forEach((sport) => {
        if (sport && (sport.id != 13 || sport.id != 15)) {
          sportsView =
            sportsView +
            `<a href="#/categories/${sport.id}" sportid="${
              sport.id
            }" class="betModuleSportBtn active hd-${sport.name}">
          <i class="sport-${sport.name}"></i>
          <span>${_t(sport.name)}</span>
        </a>`;
        }
      });
    }

    let topFiveLeagues = (blockedFootball ? Promise.resolve([]) : getTopFiveLeagues()).then((value) => {
      let getTopFiveLeaguesView = "";
      value.forEach((topFiveLeague) => {
        getTopFiveLeaguesView =
          getTopFiveLeaguesView +
          `<a class="leagueListContentItem" href="#/games/${topFiveLeague.id}" data-id="${topFiveLeague.id}">${_t(topFiveLeague.name)}</a>`;
      });

      document.getElementById("leagueHeaderContentF").innerHTML =
        getTopFiveLeaguesView;

      updateMatch();
    });

    let topTenMatchGames = (blockedFootball ? Promise.resolve([]) : getTopTenMatchGames()).then((value) => {
      let getTopTenMatchGamesView = "";
      value.forEach((topTenMatchGame) => {
        if (!topTenMatchGame.odd) {
          return;
        }
        getTopTenMatchGamesView =
          getTopTenMatchGamesView +
          `<div class="singleGameContent">
                           <a class="singleTeamNames" href="#/Match/${
                             topTenMatchGame.id
                           }" data-id="${topTenMatchGame.id}">
                               <div class="singleDateColumn">
                                  <span>${
                                    topTenMatchGame.game_time.split(":")[0]
                                  }:${
            topTenMatchGame.game_time.split(":")[1]
          }</span>
                        <span class="numberofmarkets">${
                          topTenMatchGame.count_options
                        } ></span>
                               </div>
                               <div class="singleDetailsColumn">
                                 <div class="singleTeamRowLabel">
                                   <img class="ml-TeamKit_SVG" alt="${
                                     topTenMatchGame.home_team
                                   }" src="${findTeamKit(
            topTenMatchGame.home_team
          )}" lazy onerror="this.src='${
            window.location.pathname
          }img/teams/NoKit.svg?v=2'" width="20" height="20" />
                                   <span class="singleHomeName">${
                                     topTenMatchGame.home_team
                                   }</span>
                                   <span class="gameSingleHomeScore"></span>
                                 </div>
                                 <div class="singleTeamRowLabel">
                                   <img class="ml-TeamKit_SVG" alt="${
                                     topTenMatchGame.away_team
                                   }" src="${findTeamKit(
            topTenMatchGame.away_team
          )}" lazy onerror="this.src='${
            window.location.pathname
          }img/teams/NoKit.svg?v=2'" width="20" height="20" />
                                   <span class="singleAwayName">${
                                     topTenMatchGame.away_team
                                   }</span>
                                   <span class="gameSingleAwayScore"></span>
                                 </div>
                               </div>
                           </a>
                           <div class="singleHomeOdd bettingBtn  ${
                             Math.floor(
                               (parseFloat(
                                 topTenMatchGame.odd.split(",")[0].split("|")[1]
                               ) +
                                 Number.EPSILON) *
                                 100
                             ) /
                               100 ==
                             1
                               ? "disabledBtn"
                               : ""
                           } ${
            topTenMatchGame.odd.split(",")[0].split("|")[0]
          }" match-odd="${
            Math.floor(
              (parseFloat(topTenMatchGame.odd.split(",")[0].split("|")[1]) +
                Number.EPSILON) *
                100
            ) / 100
          }" match-home-name="${topTenMatchGame.home_team}" match-away-name="${
            topTenMatchGame.away_team
          }" match-market="Rezultat Final"  match-market-option="1 " coef-id="${
            topTenMatchGame.odd.split(",")[0].split("|")[0]
          }" bet-id="${
            topTenMatchGame.odd.split(",")[0].split("|")[0]
          }" game-id="${topTenMatchGame.id}">${(
            Math.floor(
              (parseFloat(topTenMatchGame.odd.split(",")[0].split("|")[1]) +
                Number.EPSILON) *
                100
            ) / 100
          ).toFixed(2)}</div>
                           <div class="singleDrawOdd bettingBtn  ${
                             Math.floor(
                               (parseFloat(
                                 topTenMatchGame.odd.split(",")[1].split("|")[1]
                               ) +
                                 Number.EPSILON) *
                                 100
                             ) /
                               100 ==
                             1
                               ? "disabledBtn"
                               : ""
                           }  ${
            topTenMatchGame.odd.split(",")[1].split("|")[0]
          }" match-odd="${(
            Math.floor(
              (parseFloat(topTenMatchGame.odd.split(",")[1].split("|")[1]) +
                Number.EPSILON) *
                100
            ) / 100
          ).toFixed(2)}" match-home-name="${
            topTenMatchGame.home_team
          }" match-away-name="${
            topTenMatchGame.away_team
          }" match-market="Rezultat Final"  match-market-option="X " coef-id="${
            topTenMatchGame.odd.split(",")[1].split("|")[0]
          }" bet-id="${
            topTenMatchGame.odd.split(",")[1].split("|")[0]
          }" game-id="${topTenMatchGame.id}">${(
            Math.floor(
              (parseFloat(topTenMatchGame.odd.split(",")[1].split("|")[1]) +
                Number.EPSILON) *
                100
            ) / 100
          ).toFixed(2)}</div>
                           <div class="singleAwayOdd bettingBtn  ${
                             (
                               Math.floor(
                                 (parseFloat(
                                   topTenMatchGame.odd
                                     .split(",")[2]
                                     .split("|")[1]
                                 ) +
                                   Number.EPSILON) *
                                   100
                               ) / 100
                             ).toFixed(2) == 1
                               ? "disabledBtn"
                               : ""
                           } ${
            topTenMatchGame.odd.split(",")[2].split("|")[0]
          }" match-odd="${(
            Math.floor(
              (parseFloat(topTenMatchGame.odd.split(",")[2].split("|")[1]) +
                Number.EPSILON) *
                100
            ) / 100
          ).toFixed(2)}" match-home-name="${
            topTenMatchGame.home_team
          }" match-away-name="${
            topTenMatchGame.away_team
          }" match-market="Rezultat Final"  match-market-option="2 " coef-id="${
            topTenMatchGame.odd.split(",")[2].split("|")[0]
          }" bet-id="${
            topTenMatchGame.odd.split(",")[2].split("|")[0]
          }" game-id="${topTenMatchGame.id}">${(
            Math.floor(
              (parseFloat(topTenMatchGame.odd.split(",")[2].split("|")[1]) +
                Number.EPSILON) *
                100
            ) / 100
          ).toFixed(2)}</div>
                         </div>`;
      });

      document.getElementById("getTopTenMatchGamesViewF").innerHTML =
        getTopTenMatchGamesView;

      updateMatch();
    });
    let topTenLiveGames = (blockedFootball ? Promise.resolve([]) : getTopTenLiveGames()).then((value) => {
      let getTopTenLiveGamesView = "";

      value.forEach((topTenLiveGame) => {
        if (topTenLiveGame.id != 372481) {
          getTopTenLiveGamesView =
            getTopTenLiveGamesView + getLiveTemplate(topTenLiveGame);

          const check = timers.find((a) => a.game_id == topTenLiveGame.id);
          const timerId = setInterval(
            () => liveTimer(`${topTenLiveGame.id}-timer`),
            1000
          );
          if (check) {
            clearInterval(check.timerId);
            check.timerId = timerId;
          } else {
            timers.push({
              game_id: topTenLiveGame.id,
              timerId,
            });
          }
        }
      });
      document.getElementById("getTopTenLiveGamesViewF").innerHTML =
        getTopTenLiveGamesView;

      updateMatch();
    });

    let view = /*html*/ `
          <div class="pageSection">
            <div class="main-categories-container">
                <a href="#/" class="main-category-item">
                  <div class="main-category-item-icon sports"></div>
                  <div class="main-category-item-title">${_t("Sports")}</div>
                </a>
                <a href="#/InPlay" class="main-category-item">
                  <div class="main-category-item-icon live"></div>
                  <div class="main-category-item-title">${_t("Bast Live")}</div>
                </a>
                <a onclick="showCasinoMenu()" class="main-category-item">
                  <div class="main-category-item-icon casino"></div>
                  <div class="main-category-item-title">${_t("Casino")}</div>
                </a>
                <a onclick="launchvirtualgames()" class="main-category-item">
                  <div class="main-category-item-icon virtual"></div>
                  <div class="main-category-item-title">${_t("Virtual")}</div>
                </a>
            </div>
            <div class="jackpot-container">
                <div class="jackpot-box">
                    <div class="jackpot-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" height="800px" width="800px" version="1.1" id="Layer_1" viewBox="0 0 512 512" xml:space="preserve">
                            <circle style="fill:#FFEAE0;" cx="256" cy="256" r="256"/>
                            <path style="fill:#FFE0CC;" d="M370.759,476.69c-141.385,0-256-114.615-256-256c0-93.654,50.316-175.521,125.364-220.151  C106.14,8.745,0,119.953,0,256c0,141.385,114.615,256,256,256c47.732,0,92.386-13.103,130.636-35.849  C381.379,476.472,376.095,476.69,370.759,476.69z"/>
                            <path style="fill:#767676;" d="M187.409,64.903l-19.511,59.913c-2.367,7.268-9.143,12.189-16.788,12.189H88.045  c-7.652,0-14.433-4.929-16.793-12.207L60.292,91.012c24.364-28.954,55.084-52.436,90.041-68.149l30.667,22.292  C187.191,49.654,189.778,57.628,187.409,64.903z"/>
                            <g>
                                <path style="fill:#FFE0CC;" d="M342.334,14.919l-30.048,21.867c-3.018,2.197-6.655,3.38-10.389,3.38h-91.976   c-3.731,0-7.364-1.182-10.382-3.375l-29.961-21.783C196.59,5.297,225.633,0,256,0C286.279,0,315.41,5.297,342.334,14.919z"/>
                                <path style="fill:#FFE0CC;" d="M466.538,401.655c-31.868,45.992-78.477,81.125-132.943,98.339l10.839-33.279   c1.106-3.393,3.172-6.342,6.005-8.512c13.505-10.355,54.948-42.131,69.006-52.92c3.084-2.367,6.834-3.628,10.721-3.628   L466.538,401.655L466.538,401.655z"/>
                            </g>
                            <g>
                                <path style="fill:#767676;" d="M511.117,276.568c-3.001,38.93-14.919,75.388-33.545,107.432h-38.1   c-7.652,0-14.434-4.93-16.794-12.21l-19.453-59.989c-2.358-7.272,0.232-15.235,6.417-19.729l51.022-37.074   c7.648-0.001,13.105-0.001,20.753-0.002L511.117,276.568z"/>
                                <path style="fill:#767676;" d="M323.698,473.28l-10.495,32.188C294.841,509.793,275.686,512,256,512   c-19.774,0-39.018-2.207-57.468-6.532l-10.435-32.203c-2.357-7.275,0.236-15.24,6.425-19.732l51.02-37.025   c6.185-4.488,14.554-4.488,20.739,0l51,37.011C323.48,458.017,326.071,465.998,323.698,473.28z"/>
                            </g>
                            <path style="fill:#FFD6B3;" d="M178.141,499.641c-54.378-17.302-100.811-51.994-132.679-97.986h35.967  c3.876,0,7.614,1.252,10.692,3.606c14.114,10.793,55.796,42.731,69.348,53.118c2.835,2.172,4.903,5.121,6.008,8.516L178.141,499.641  z"/>
                            <path style="fill:black;" d="M108.599,311.799L89.146,371.79C86.785,379.07,80.003,384,72.351,384H34.428  C15.713,351.956,3.884,315.498,0.883,276.48L30.4,254.995c6.19-4.505,14.579-4.508,20.771-0.007l51.015,37.085  C108.367,296.567,110.956,304.529,108.599,311.799z"/>
                            <path style="fill:#FFD6B3;" d="M57.766,151.079l-24.137,75.571c-1.144,3.583-3.404,6.708-6.449,8.917L0,255.294  c0.177-54.908,17.567-105.754,47.228-147.332l10.508,32.28C58.881,143.762,58.892,147.552,57.766,151.079z"/>
                            <path style="fill:#FFE0CC;" d="M512,255.382l-27.708-20.083c-3.047-2.208-5.308-5.332-6.454-8.915l-23.948-74.847  c-1.132-3.537-1.119-7.341,0.035-10.871l10.759-32.883C494.433,149.451,511.912,200.386,512,255.382z"/>
                            <path style="fill:#767676;" d="M451.531,90.924l-10.963,33.863c-2.358,7.284-9.141,12.217-16.797,12.217h-63.058  c-7.645,0-14.42-4.919-16.788-12.189l-19.512-59.917c-2.368-7.273,0.216-15.244,6.401-19.744l30.763-22.379  C396.535,38.488,427.167,62.058,451.531,90.924z"/>
                            <g>
                                <path style="fill:#FFE0CC;" d="M400.214,397.857l-52.63,40.285c-6.204,4.748-14.792,4.855-21.111,0.262l-54.458-39.582   c-4.57-3.322-7.275-8.631-7.275-14.282v-25.708c0-5.651,2.705-10.959,7.276-14.282l62.079-45.116   c4.165-3.027,9.445-4.085,14.455-2.897l24.118,5.722c5.996,1.422,10.816,5.868,12.717,11.73l20.892,64.398   C408.586,385.507,406.156,393.309,400.214,397.857z"/>
                                <path style="fill:#FFE0CC;" d="M247.084,358.837v25.705c0,5.649-2.703,10.957-7.272,14.279l-54.557,39.672   c-6.316,4.593-14.899,4.491-21.103-0.252l-52.609-40.204c-5.953-4.549-8.386-12.361-6.07-19.487l21.068-64.8   c1.895-5.827,6.675-10.255,12.629-11.699l23.626-5.729c5.031-1.22,10.344-0.17,14.534,2.871l62.473,45.356   C244.376,347.872,247.084,353.183,247.084,358.837z"/>
                                <path style="fill:#FFE0CC;" d="M192.185,200.324l-21.866,67.334c-1.888,5.814-6.649,10.238-12.587,11.694l-24.247,5.947   c-5.047,1.238-10.382,0.19-14.585-2.866l-58.349-42.411c-6.162-4.478-8.756-12.403-6.436-19.658l17.081-53.426   c2.338-7.315,9.138-12.278,16.817-12.278h69.704c5.426,0,10.55,2.495,13.897,6.765l17.676,22.558   C192.916,188.608,194.001,194.734,192.185,200.324z"/>
                            </g>
                            <path style="fill:#767676;" d="M317.289,289.847l-51.007,37.016c-6.185,4.488-14.554,4.488-20.739,0l-51.007-37.016  c-6.195-4.495-8.788-12.471-6.42-19.751l19.516-59.989c2.366-7.272,9.143-12.193,16.789-12.193h62.985  c7.647,0,14.423,4.922,16.789,12.193l19.516,59.989C326.076,277.376,323.484,285.352,317.289,289.847z"/>
                            <g>
                                <path style="fill:#FFE0CC;" d="M450.999,240.201l-58.306,42.361c-4.172,3.031-9.462,4.087-14.478,2.889l-23.876-5.702   c-5.977-1.428-10.782-5.86-12.685-11.703l-22.113-67.87c-1.811-5.557-0.754-11.649,2.822-16.271l17.321-22.392   c3.343-4.322,8.5-6.854,13.965-6.854h69.815c7.677,0,14.474,4.961,16.814,12.273l17.16,53.603   C459.761,227.791,457.164,235.721,450.999,240.201z"/>
                                <path style="fill:#FFE0CC;" d="M325.668,150.831l-17.493,22.584c-3.343,4.317-8.498,6.844-13.958,6.844h-76.781   c-5.415,0-10.53-2.485-13.878-6.741l-17.473-22.219c-3.641-4.63-4.734-10.771-2.912-16.373l21.105-64.909   c2.365-7.273,9.142-12.196,16.79-12.196h69.684c7.65,0,14.43,4.927,16.792,12.202l20.96,64.544   C330.307,140.122,329.247,146.212,325.668,150.831z"/>
                            </g>
                            <g>
                                <path style="fill:#FFD6B3;" d="M195.777,34.054c13.444-12.605,28.169-23.858,44.09-33.352c-1.11,0.07-2.241,0.062-3.348,0.146   c-1.953,0.148-3.902,0.31-5.842,0.501c-5.768,0.569-11.485,1.302-17.13,2.249c-1.67,0.278-3.32,0.608-4.978,0.918   c-5.937,1.118-11.828,2.365-17.613,3.885c-0.878,0.23-1.736,0.506-2.611,0.746c-5.91,1.622-11.745,3.431-17.481,5.459   c-0.416,0.147-0.841,0.276-1.256,0.425L195.777,34.054z"/>
                                <path style="fill:#FFD6B3;" d="M122.782,284.511c-5.235-20.402-8.023-41.786-8.023-63.821c0-22.84,3.039-44.962,8.653-66.03H88.013   c-7.679,0-14.478,4.964-16.817,12.278l-17.081,53.426c-2.319,7.255,0.275,15.18,6.436,19.658l58.348,42.411   C120.107,283.309,121.422,283.971,122.782,284.511z"/>
                                <path style="fill:#FFD6B3;" d="M130.001,307.848c-1.479,1.734-2.734,3.668-3.46,5.902l-21.068,64.8   c-2.317,7.126,0.116,14.937,6.069,19.487l52.61,40.204c6.205,4.742,14.787,4.844,21.103,0.252l25.163-18.297   C174.231,391.075,146.115,352.35,130.001,307.848z"/>
                            </g>
                            <path style="fill:black;" d="M277.618,510.994c3.592-0.301,7.169-0.657,10.717-1.105c2.308-0.296,4.604-0.633,6.891-0.992  c2.582-0.398,5.144-0.854,7.7-1.329c3.238-0.615,6.473-1.234,9.663-1.976c0.209-0.046,0.414-0.104,0.622-0.151l10.486-32.161  c0.103-0.314,0.066-0.639,0.15-0.956c-36.11-6.691-69.551-20.932-98.63-41.069l-30.696,22.276  c-6.189,4.491-8.782,12.457-6.425,19.732l10.428,32.177c0.303,0.069,0.608,0.142,0.913,0.211c3.442,0.792,6.923,1.475,10.418,2.12  c1.513,0.276,3.02,0.562,4.542,0.811c2.756,0.456,5.538,0.83,8.323,1.193c1.868,0.243,3.727,0.511,5.609,0.713  c2.841,0.306,5.71,0.519,8.58,0.729c1.726,0.128,3.441,0.3,5.175,0.393C246.691,511.855,251.329,512,256,512  c5.516,0,10.98-0.216,16.409-0.562C274.156,511.328,275.881,511.14,277.618,510.994z"/>
                            <path style="fill:#FFD6B3;" d="M370.759,476.69c-9.82,0-19.494-0.607-29.025-1.684l-8.087,24.83  c0.978-0.311,1.964-0.604,2.936-0.927c4.162-1.374,8.256-2.895,12.321-4.476c2.185-0.853,4.398-1.65,6.553-2.56  c5.028-2.118,9.961-4.416,14.819-6.844c2.815-1.408,5.555-2.933,8.31-4.44c2.629-1.438,5.24-2.903,7.814-4.43  C381.22,476.472,376.015,476.69,370.759,476.69z"/>
                            <path style="fill:black;" d="M128.762,137.004c11.689-33.784,30.347-64.271,54.116-89.963c-0.632-0.627-1.142-1.351-1.878-1.886  l-30.652-22.281c-0.167,0.076-0.335,0.148-0.503,0.225c-3.556,1.608-7.049,3.328-10.515,5.095c-0.883,0.454-1.782,0.879-2.658,1.342  c-3.125,1.64-6.188,3.379-9.235,5.144c-2.514,1.462-4.986,2.982-7.445,4.526c-1.823,1.142-3.657,2.265-5.449,3.453  c-2.166,1.439-4.284,2.944-6.402,4.447c-1.367,0.968-2.739,1.93-4.086,2.924c-2.109,1.558-4.184,3.157-6.242,4.778  c-1.331,1.047-2.648,2.108-3.957,3.181c-1.974,1.617-3.933,3.251-5.857,4.925c-1.428,1.245-2.824,2.525-4.224,3.8  c-1.735,1.579-3.48,3.146-5.172,4.771c-2.487,2.396-4.916,4.851-7.305,7.346c-0.946,0.985-1.885,1.976-2.815,2.976  c-2.603,2.807-5.16,5.657-7.635,8.579c-0.185,0.218-0.361,0.445-0.546,0.664l10.946,33.747c2.361,7.278,9.142,12.207,16.794,12.207  h40.718V137.004z"/>
                        </svg>
                    </div>
                    <div class="jackpot-content">
                    <p class="jackpot-title">${_t('Prematch jackpot')}</p>
                    <p class="jackpot-value">${
                      jackpotvalue && jackpotvalue.actual_jackpot_prematch
                        ? (+jackpotvalue.actual_jackpot_prematch).toFixed(2)
                        : "00.00"
                    } €</p>
                    </div>
                </div>
                <div class="jackpot-box">
                    <div class="jackpot-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" height="800px" width="800px" version="1.1" id="Layer_1" viewBox="0 0 512 512" xml:space="preserve">
                            <circle style="fill:#fffefd;" cx="256" cy="256" r="256"/>
                            <path style="fill:#e3e3e3;" d="M370.759,476.69c-141.385,0-256-114.615-256-256c0-93.654,50.316-175.521,125.364-220.151  C106.14,8.745,0,119.953,0,256c0,141.385,114.615,256,256,256c47.732,0,92.386-13.103,130.636-35.849  C381.379,476.472,376.095,476.69,370.759,476.69z"/>
                            <path style="fill:#767676;" d="M187.409,64.903l-19.511,59.913c-2.367,7.268-9.143,12.189-16.788,12.189H88.045  c-7.652,0-14.433-4.929-16.793-12.207L60.292,91.012c24.364-28.954,55.084-52.436,90.041-68.149l30.667,22.292  C187.191,49.654,189.778,57.628,187.409,64.903z"/>
                            <g>
                                <path style="fill:#e3e3e3;" d="M342.334,14.919l-30.048,21.867c-3.018,2.197-6.655,3.38-10.389,3.38h-91.976   c-3.731,0-7.364-1.182-10.382-3.375l-29.961-21.783C196.59,5.297,225.633,0,256,0C286.279,0,315.41,5.297,342.334,14.919z"/>
                                <path style="fill:#e3e3e3;" d="M466.538,401.655c-31.868,45.992-78.477,81.125-132.943,98.339l10.839-33.279   c1.106-3.393,3.172-6.342,6.005-8.512c13.505-10.355,54.948-42.131,69.006-52.92c3.084-2.367,6.834-3.628,10.721-3.628   L466.538,401.655L466.538,401.655z"/>
                            </g>
                            <g>
                                <path style="fill:#767676;" d="M511.117,276.568c-3.001,38.93-14.919,75.388-33.545,107.432h-38.1   c-7.652,0-14.434-4.93-16.794-12.21l-19.453-59.989c-2.358-7.272,0.232-15.235,6.417-19.729l51.022-37.074   c7.648-0.001,13.105-0.001,20.753-0.002L511.117,276.568z"/>
                                <path style="fill:#767676;" d="M323.698,473.28l-10.495,32.188C294.841,509.793,275.686,512,256,512   c-19.774,0-39.018-2.207-57.468-6.532l-10.435-32.203c-2.357-7.275,0.236-15.24,6.425-19.732l51.02-37.025   c6.185-4.488,14.554-4.488,20.739,0l51,37.011C323.48,458.017,326.071,465.998,323.698,473.28z"/>
                            </g>
                            <path style="fill:#cbcbcb;" d="M178.141,499.641c-54.378-17.302-100.811-51.994-132.679-97.986h35.967  c3.876,0,7.614,1.252,10.692,3.606c14.114,10.793,55.796,42.731,69.348,53.118c2.835,2.172,4.903,5.121,6.008,8.516L178.141,499.641  z"/>
                            <path style="fill:black;" d="M108.599,311.799L89.146,371.79C86.785,379.07,80.003,384,72.351,384H34.428  C15.713,351.956,3.884,315.498,0.883,276.48L30.4,254.995c6.19-4.505,14.579-4.508,20.771-0.007l51.015,37.085  C108.367,296.567,110.956,304.529,108.599,311.799z"/>
                            <path style="fill:#cbcbcb;" d="M57.766,151.079l-24.137,75.571c-1.144,3.583-3.404,6.708-6.449,8.917L0,255.294  c0.177-54.908,17.567-105.754,47.228-147.332l10.508,32.28C58.881,143.762,58.892,147.552,57.766,151.079z"/>
                            <path style="fill:#e3e3e3;" d="M512,255.382l-27.708-20.083c-3.047-2.208-5.308-5.332-6.454-8.915l-23.948-74.847  c-1.132-3.537-1.119-7.341,0.035-10.871l10.759-32.883C494.433,149.451,511.912,200.386,512,255.382z"/>
                            <path style="fill:#767676;" d="M451.531,90.924l-10.963,33.863c-2.358,7.284-9.141,12.217-16.797,12.217h-63.058  c-7.645,0-14.42-4.919-16.788-12.189l-19.512-59.917c-2.368-7.273,0.216-15.244,6.401-19.744l30.763-22.379  C396.535,38.488,427.167,62.058,451.531,90.924z"/>
                            <g>
                                <path style="fill:#e3e3e3;" d="M400.214,397.857l-52.63,40.285c-6.204,4.748-14.792,4.855-21.111,0.262l-54.458-39.582   c-4.57-3.322-7.275-8.631-7.275-14.282v-25.708c0-5.651,2.705-10.959,7.276-14.282l62.079-45.116   c4.165-3.027,9.445-4.085,14.455-2.897l24.118,5.722c5.996,1.422,10.816,5.868,12.717,11.73l20.892,64.398   C408.586,385.507,406.156,393.309,400.214,397.857z"/>
                                <path style="fill:#e3e3e3;" d="M247.084,358.837v25.705c0,5.649-2.703,10.957-7.272,14.279l-54.557,39.672   c-6.316,4.593-14.899,4.491-21.103-0.252l-52.609-40.204c-5.953-4.549-8.386-12.361-6.07-19.487l21.068-64.8   c1.895-5.827,6.675-10.255,12.629-11.699l23.626-5.729c5.031-1.22,10.344-0.17,14.534,2.871l62.473,45.356   C244.376,347.872,247.084,353.183,247.084,358.837z"/>
                                <path style="fill:#e3e3e3;" d="M192.185,200.324l-21.866,67.334c-1.888,5.814-6.649,10.238-12.587,11.694l-24.247,5.947   c-5.047,1.238-10.382,0.19-14.585-2.866l-58.349-42.411c-6.162-4.478-8.756-12.403-6.436-19.658l17.081-53.426   c2.338-7.315,9.138-12.278,16.817-12.278h69.704c5.426,0,10.55,2.495,13.897,6.765l17.676,22.558   C192.916,188.608,194.001,194.734,192.185,200.324z"/>
                            </g>
                            <path style="fill:#767676;" d="M317.289,289.847l-51.007,37.016c-6.185,4.488-14.554,4.488-20.739,0l-51.007-37.016  c-6.195-4.495-8.788-12.471-6.42-19.751l19.516-59.989c2.366-7.272,9.143-12.193,16.789-12.193h62.985  c7.647,0,14.423,4.922,16.789,12.193l19.516,59.989C326.076,277.376,323.484,285.352,317.289,289.847z"/>
                            <g>
                                <path style="fill:#e3e3e3;" d="M450.999,240.201l-58.306,42.361c-4.172,3.031-9.462,4.087-14.478,2.889l-23.876-5.702   c-5.977-1.428-10.782-5.86-12.685-11.703l-22.113-67.87c-1.811-5.557-0.754-11.649,2.822-16.271l17.321-22.392   c3.343-4.322,8.5-6.854,13.965-6.854h69.815c7.677,0,14.474,4.961,16.814,12.273l17.16,53.603   C459.761,227.791,457.164,235.721,450.999,240.201z"/>
                                <path style="fill:#e3e3e3;" d="M325.668,150.831l-17.493,22.584c-3.343,4.317-8.498,6.844-13.958,6.844h-76.781   c-5.415,0-10.53-2.485-13.878-6.741l-17.473-22.219c-3.641-4.63-4.734-10.771-2.912-16.373l21.105-64.909   c2.365-7.273,9.142-12.196,16.79-12.196h69.684c7.65,0,14.43,4.927,16.792,12.202l20.96,64.544   C330.307,140.122,329.247,146.212,325.668,150.831z"/>
                            </g>
                            <g>
                                <path style="fill:#cbcbcb;" d="M195.777,34.054c13.444-12.605,28.169-23.858,44.09-33.352c-1.11,0.07-2.241,0.062-3.348,0.146   c-1.953,0.148-3.902,0.31-5.842,0.501c-5.768,0.569-11.485,1.302-17.13,2.249c-1.67,0.278-3.32,0.608-4.978,0.918   c-5.937,1.118-11.828,2.365-17.613,3.885c-0.878,0.23-1.736,0.506-2.611,0.746c-5.91,1.622-11.745,3.431-17.481,5.459   c-0.416,0.147-0.841,0.276-1.256,0.425L195.777,34.054z"/>
                                <path style="fill:#cbcbcb;" d="M122.782,284.511c-5.235-20.402-8.023-41.786-8.023-63.821c0-22.84,3.039-44.962,8.653-66.03H88.013   c-7.679,0-14.478,4.964-16.817,12.278l-17.081,53.426c-2.319,7.255,0.275,15.18,6.436,19.658l58.348,42.411   C120.107,283.309,121.422,283.971,122.782,284.511z"/>
                                <path style="fill:#cbcbcb;" d="M130.001,307.848c-1.479,1.734-2.734,3.668-3.46,5.902l-21.068,64.8   c-2.317,7.126,0.116,14.937,6.069,19.487l52.61,40.204c6.205,4.742,14.787,4.844,21.103,0.252l25.163-18.297   C174.231,391.075,146.115,352.35,130.001,307.848z"/>
                            </g>
                            <path style="fill:black;" d="M277.618,510.994c3.592-0.301,7.169-0.657,10.717-1.105c2.308-0.296,4.604-0.633,6.891-0.992  c2.582-0.398,5.144-0.854,7.7-1.329c3.238-0.615,6.473-1.234,9.663-1.976c0.209-0.046,0.414-0.104,0.622-0.151l10.486-32.161  c0.103-0.314,0.066-0.639,0.15-0.956c-36.11-6.691-69.551-20.932-98.63-41.069l-30.696,22.276  c-6.189,4.491-8.782,12.457-6.425,19.732l10.428,32.177c0.303,0.069,0.608,0.142,0.913,0.211c3.442,0.792,6.923,1.475,10.418,2.12  c1.513,0.276,3.02,0.562,4.542,0.811c2.756,0.456,5.538,0.83,8.323,1.193c1.868,0.243,3.727,0.511,5.609,0.713  c2.841,0.306,5.71,0.519,8.58,0.729c1.726,0.128,3.441,0.3,5.175,0.393C246.691,511.855,251.329,512,256,512  c5.516,0,10.98-0.216,16.409-0.562C274.156,511.328,275.881,511.14,277.618,510.994z"/>
                            <path style="fill:#cbcbcb;" d="M370.759,476.69c-9.82,0-19.494-0.607-29.025-1.684l-8.087,24.83  c0.978-0.311,1.964-0.604,2.936-0.927c4.162-1.374,8.256-2.895,12.321-4.476c2.185-0.853,4.398-1.65,6.553-2.56  c5.028-2.118,9.961-4.416,14.819-6.844c2.815-1.408,5.555-2.933,8.31-4.44c2.629-1.438,5.24-2.903,7.814-4.43  C381.22,476.472,376.015,476.69,370.759,476.69z"/>
                            <path style="fill:black;" d="M128.762,137.004c11.689-33.784,30.347-64.271,54.116-89.963c-0.632-0.627-1.142-1.351-1.878-1.886  l-30.652-22.281c-0.167,0.076-0.335,0.148-0.503,0.225c-3.556,1.608-7.049,3.328-10.515,5.095c-0.883,0.454-1.782,0.879-2.658,1.342  c-3.125,1.64-6.188,3.379-9.235,5.144c-2.514,1.462-4.986,2.982-7.445,4.526c-1.823,1.142-3.657,2.265-5.449,3.453  c-2.166,1.439-4.284,2.944-6.402,4.447c-1.367,0.968-2.739,1.93-4.086,2.924c-2.109,1.558-4.184,3.157-6.242,4.778  c-1.331,1.047-2.648,2.108-3.957,3.181c-1.974,1.617-3.933,3.251-5.857,4.925c-1.428,1.245-2.824,2.525-4.224,3.8  c-1.735,1.579-3.48,3.146-5.172,4.771c-2.487,2.396-4.916,4.851-7.305,7.346c-0.946,0.985-1.885,1.976-2.815,2.976  c-2.603,2.807-5.16,5.657-7.635,8.579c-0.185,0.218-0.361,0.445-0.546,0.664l10.946,33.747c2.361,7.278,9.142,12.207,16.794,12.207  h40.718V137.004z"/>
                        </svg>
                    </div>
                    <div class="jackpot-content">
                    <p class="jackpot-title">${_t('Live jackpot')}</p>
                    <p class="jackpot-value">${
                      jackpotvalue && jackpotvalue.actual_jackpot_live
                        ? (+jackpotvalue.actual_jackpot_live).toFixed(2)
                        : "00.00"
                    } €</p>
                    </div>
                </div>
                <div class="jackpot-box">
                    <div class="jackpot-icon gold">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" height="800px" width="800px" version="1.1" id="Layer_1" viewBox="0 0 512 512" xml:space="preserve">
                            <circle style="fill:#fffefd;" cx="256" cy="256" r="256"/>
                            <path style="fill:#e3e3e3;" d="M370.759,476.69c-141.385,0-256-114.615-256-256c0-93.654,50.316-175.521,125.364-220.151  C106.14,8.745,0,119.953,0,256c0,141.385,114.615,256,256,256c47.732,0,92.386-13.103,130.636-35.849  C381.379,476.472,376.095,476.69,370.759,476.69z"/>
                            <path style="fill:#ffdd3c;" d="M187.409,64.903l-19.511,59.913c-2.367,7.268-9.143,12.189-16.788,12.189H88.045  c-7.652,0-14.433-4.929-16.793-12.207L60.292,91.012c24.364-28.954,55.084-52.436,90.041-68.149l30.667,22.292  C187.191,49.654,189.778,57.628,187.409,64.903z"/>
                            <g>
                                <path style="fill:#e3e3e3;" d="M342.334,14.919l-30.048,21.867c-3.018,2.197-6.655,3.38-10.389,3.38h-91.976   c-3.731,0-7.364-1.182-10.382-3.375l-29.961-21.783C196.59,5.297,225.633,0,256,0C286.279,0,315.41,5.297,342.334,14.919z"/>
                                <path style="fill:#e3e3e3;" d="M466.538,401.655c-31.868,45.992-78.477,81.125-132.943,98.339l10.839-33.279   c1.106-3.393,3.172-6.342,6.005-8.512c13.505-10.355,54.948-42.131,69.006-52.92c3.084-2.367,6.834-3.628,10.721-3.628   L466.538,401.655L466.538,401.655z"/>
                            </g>
                            <g>
                                <path style="fill:#ffdd3c;" d="M511.117,276.568c-3.001,38.93-14.919,75.388-33.545,107.432h-38.1   c-7.652,0-14.434-4.93-16.794-12.21l-19.453-59.989c-2.358-7.272,0.232-15.235,6.417-19.729l51.022-37.074   c7.648-0.001,13.105-0.001,20.753-0.002L511.117,276.568z"/>
                                <path style="fill:#ffdd3c;" d="M323.698,473.28l-10.495,32.188C294.841,509.793,275.686,512,256,512   c-19.774,0-39.018-2.207-57.468-6.532l-10.435-32.203c-2.357-7.275,0.236-15.24,6.425-19.732l51.02-37.025   c6.185-4.488,14.554-4.488,20.739,0l51,37.011C323.48,458.017,326.071,465.998,323.698,473.28z"/>
                            </g>
                            <path style="fill:#000000;" d="M178.141,499.641c-54.378-17.302-100.811-51.994-132.679-97.986h35.967  c3.876,0,7.614,1.252,10.692,3.606c14.114,10.793,55.796,42.731,69.348,53.118c2.835,2.172,4.903,5.121,6.008,8.516L178.141,499.641  z"/>
                            <path style="fill:#edc300;" d="M108.599,311.799L89.146,371.79C86.785,379.07,80.003,384,72.351,384H34.428  C15.713,351.956,3.884,315.498,0.883,276.48L30.4,254.995c6.19-4.505,14.579-4.508,20.771-0.007l51.015,37.085  C108.367,296.567,110.956,304.529,108.599,311.799z"/>
                            <path style="fill:#000000;" d="M57.766,151.079l-24.137,75.571c-1.144,3.583-3.404,6.708-6.449,8.917L0,255.294  c0.177-54.908,17.567-105.754,47.228-147.332l10.508,32.28C58.881,143.762,58.892,147.552,57.766,151.079z"/>
                            <path style="fill:#e3e3e3;" d="M512,255.382l-27.708-20.083c-3.047-2.208-5.308-5.332-6.454-8.915l-23.948-74.847  c-1.132-3.537-1.119-7.341,0.035-10.871l10.759-32.883C494.433,149.451,511.912,200.386,512,255.382z"/>
                            <path style="fill:#ffdd3c;" d="M451.531,90.924l-10.963,33.863c-2.358,7.284-9.141,12.217-16.797,12.217h-63.058  c-7.645,0-14.42-4.919-16.788-12.189l-19.512-59.917c-2.368-7.273,0.216-15.244,6.401-19.744l30.763-22.379  C396.535,38.488,427.167,62.058,451.531,90.924z"/>
                            <g>
                                <path style="fill:#e3e3e3;" d="M400.214,397.857l-52.63,40.285c-6.204,4.748-14.792,4.855-21.111,0.262l-54.458-39.582   c-4.57-3.322-7.275-8.631-7.275-14.282v-25.708c0-5.651,2.705-10.959,7.276-14.282l62.079-45.116   c4.165-3.027,9.445-4.085,14.455-2.897l24.118,5.722c5.996,1.422,10.816,5.868,12.717,11.73l20.892,64.398   C408.586,385.507,406.156,393.309,400.214,397.857z"/>
                                <path style="fill:#e3e3e3;" d="M247.084,358.837v25.705c0,5.649-2.703,10.957-7.272,14.279l-54.557,39.672   c-6.316,4.593-14.899,4.491-21.103-0.252l-52.609-40.204c-5.953-4.549-8.386-12.361-6.07-19.487l21.068-64.8   c1.895-5.827,6.675-10.255,12.629-11.699l23.626-5.729c5.031-1.22,10.344-0.17,14.534,2.871l62.473,45.356   C244.376,347.872,247.084,353.183,247.084,358.837z"/>
                                <path style="fill:#e3e3e3;" d="M192.185,200.324l-21.866,67.334c-1.888,5.814-6.649,10.238-12.587,11.694l-24.247,5.947   c-5.047,1.238-10.382,0.19-14.585-2.866l-58.349-42.411c-6.162-4.478-8.756-12.403-6.436-19.658l17.081-53.426   c2.338-7.315,9.138-12.278,16.817-12.278h69.704c5.426,0,10.55,2.495,13.897,6.765l17.676,22.558   C192.916,188.608,194.001,194.734,192.185,200.324z"/>
                            </g>
                            <path style="fill:#ffdd3c;" d="M317.289,289.847l-51.007,37.016c-6.185,4.488-14.554,4.488-20.739,0l-51.007-37.016  c-6.195-4.495-8.788-12.471-6.42-19.751l19.516-59.989c2.366-7.272,9.143-12.193,16.789-12.193h62.985  c7.647,0,14.423,4.922,16.789,12.193l19.516,59.989C326.076,277.376,323.484,285.352,317.289,289.847z"/>
                            <g>
                                <path style="fill:#e3e3e3;" d="M450.999,240.201l-58.306,42.361c-4.172,3.031-9.462,4.087-14.478,2.889l-23.876-5.702   c-5.977-1.428-10.782-5.86-12.685-11.703l-22.113-67.87c-1.811-5.557-0.754-11.649,2.822-16.271l17.321-22.392   c3.343-4.322,8.5-6.854,13.965-6.854h69.815c7.677,0,14.474,4.961,16.814,12.273l17.16,53.603   C459.761,227.791,457.164,235.721,450.999,240.201z"/>
                                <path style="fill:#e3e3e3;" d="M325.668,150.831l-17.493,22.584c-3.343,4.317-8.498,6.844-13.958,6.844h-76.781   c-5.415,0-10.53-2.485-13.878-6.741l-17.473-22.219c-3.641-4.63-4.734-10.771-2.912-16.373l21.105-64.909   c2.365-7.273,9.142-12.196,16.79-12.196h69.684c7.65,0,14.43,4.927,16.792,12.202l20.96,64.544   C330.307,140.122,329.247,146.212,325.668,150.831z"/>
                            </g>
                            <g>
                                <path style="fill:#000000;" d="M195.777,34.054c13.444-12.605,28.169-23.858,44.09-33.352c-1.11,0.07-2.241,0.062-3.348,0.146   c-1.953,0.148-3.902,0.31-5.842,0.501c-5.768,0.569-11.485,1.302-17.13,2.249c-1.67,0.278-3.32,0.608-4.978,0.918   c-5.937,1.118-11.828,2.365-17.613,3.885c-0.878,0.23-1.736,0.506-2.611,0.746c-5.91,1.622-11.745,3.431-17.481,5.459   c-0.416,0.147-0.841,0.276-1.256,0.425L195.777,34.054z"/>
                                <path style="fill:#000000;" d="M122.782,284.511c-5.235-20.402-8.023-41.786-8.023-63.821c0-22.84,3.039-44.962,8.653-66.03H88.013   c-7.679,0-14.478,4.964-16.817,12.278l-17.081,53.426c-2.319,7.255,0.275,15.18,6.436,19.658l58.348,42.411   C120.107,283.309,121.422,283.971,122.782,284.511z"/>
                                <path style="fill:#000000;" d="M130.001,307.848c-1.479,1.734-2.734,3.668-3.46,5.902l-21.068,64.8   c-2.317,7.126,0.116,14.937,6.069,19.487l52.61,40.204c6.205,4.742,14.787,4.844,21.103,0.252l25.163-18.297   C174.231,391.075,146.115,352.35,130.001,307.848z"/>
                            </g>
                            <path style="fill:#edc300;" d="M277.618,510.994c3.592-0.301,7.169-0.657,10.717-1.105c2.308-0.296,4.604-0.633,6.891-0.992  c2.582-0.398,5.144-0.854,7.7-1.329c3.238-0.615,6.473-1.234,9.663-1.976c0.209-0.046,0.414-0.104,0.622-0.151l10.486-32.161  c0.103-0.314,0.066-0.639,0.15-0.956c-36.11-6.691-69.551-20.932-98.63-41.069l-30.696,22.276  c-6.189,4.491-8.782,12.457-6.425,19.732l10.428,32.177c0.303,0.069,0.608,0.142,0.913,0.211c3.442,0.792,6.923,1.475,10.418,2.12  c1.513,0.276,3.02,0.562,4.542,0.811c2.756,0.456,5.538,0.83,8.323,1.193c1.868,0.243,3.727,0.511,5.609,0.713  c2.841,0.306,5.71,0.519,8.58,0.729c1.726,0.128,3.441,0.3,5.175,0.393C246.691,511.855,251.329,512,256,512  c5.516,0,10.98-0.216,16.409-0.562C274.156,511.328,275.881,511.14,277.618,510.994z"/>
                            <path style="fill:#000000;" d="M370.759,476.69c-9.82,0-19.494-0.607-29.025-1.684l-8.087,24.83  c0.978-0.311,1.964-0.604,2.936-0.927c4.162-1.374,8.256-2.895,12.321-4.476c2.185-0.853,4.398-1.65,6.553-2.56  c5.028-2.118,9.961-4.416,14.819-6.844c2.815-1.408,5.555-2.933,8.31-4.44c2.629-1.438,5.24-2.903,7.814-4.43  C381.22,476.472,376.015,476.69,370.759,476.69z"/>
                            <path style="fill:#edc300;" d="M128.762,137.004c11.689-33.784,30.347-64.271,54.116-89.963c-0.632-0.627-1.142-1.351-1.878-1.886  l-30.652-22.281c-0.167,0.076-0.335,0.148-0.503,0.225c-3.556,1.608-7.049,3.328-10.515,5.095c-0.883,0.454-1.782,0.879-2.658,1.342  c-3.125,1.64-6.188,3.379-9.235,5.144c-2.514,1.462-4.986,2.982-7.445,4.526c-1.823,1.142-3.657,2.265-5.449,3.453  c-2.166,1.439-4.284,2.944-6.402,4.447c-1.367,0.968-2.739,1.93-4.086,2.924c-2.109,1.558-4.184,3.157-6.242,4.778  c-1.331,1.047-2.648,2.108-3.957,3.181c-1.974,1.617-3.933,3.251-5.857,4.925c-1.428,1.245-2.824,2.525-4.224,3.8  c-1.735,1.579-3.48,3.146-5.172,4.771c-2.487,2.396-4.916,4.851-7.305,7.346c-0.946,0.985-1.885,1.976-2.815,2.976  c-2.603,2.807-5.16,5.657-7.635,8.579c-0.185,0.218-0.361,0.445-0.546,0.664l10.946,33.747c2.361,7.278,9.142,12.207,16.794,12.207  h40.718V137.004z"/>
                        </svg>
                    </div>
                    <div class="jackpot-content">
                    <p class="jackpot-title">${_t('Actual jackpot')}</p>
                    <p class="jackpot-value">${
                      jackpotvalue && jackpotvalue.actual_jackpot
                        ? (+jackpotvalue.actual_jackpot).toFixed(2)
                        : "00.00"
                    } €</p>
                    
                    </div>
                </div>
            </div>

              <div class="firstColumn">
              <div class="betModule liveInModule sportsLanding">
                <div class="betModuleTabs">
                   <div class="betModuleTabsBtn">
                     ${sportsView}
                   </div>
                 </div>
               </div>
               <div class="jcakpotHolder jackpotHolderMain" hidden>
                    <div class="jackpotHeader">
                        <div class="jackpotLeftHeader">
                            <span>${_t("Live jackpot")}</span>
                            <span>${parseFloat(
                              localStorage.getItem("jackpot_live")
                                ? parseFloat(
                                    localStorage.getItem("jackpot_live")
                                  )
                                : 0
                            ).toFixed(2)}&euro;</span>
                        </div>
                        <div class="jackpotRightHeader">
                            <span>${_t("Prematch jackpot")}</span>
                            <span>${parseFloat(
                              localStorage.getItem("jackpot_prematch")
                                ? parseFloat(
                                    localStorage.getItem("jackpot_prematch")
                                  )
                                : 0
                            ).toFixed(2)}&euro;</span>
                        </div>
                    </div>
                </div>
        
            <!--<div class="betModule liveInModule accordionDisable widthFull ${
              mainLeagueMatchesView == "" ? "hideMe" : ""
            } " style="height: 34px" ${
      location.host === "365omegaa.com" && "hidden"
    }>
                 <div class="betModuleHeaderContainer">
                   <a class="betModuleHeaderBtn">
                     <span style="line-height: 32px;">${mainLeagueName}</span>
                     <span class="yellowColored"></span>
                   </a>
                   <a class="betHeaderEventBtn" href="#/inPlay">

                   </a>
                 </div>
            </div>
            <div class="featuredPrematchWrapper widthFull" style="" ${
              location.host === "365omegaa.com" && "hidden"
            }>
                <div class="featuredPrematchSlider ">
                    ${mainLeagueMatchesView}
                </div>
            </div> -->
            <div class="betModule liveInModule accordionDisable" style="height: 34px; ${
              location.host === "365ebet365.com" && "display: none;"
            }">
                <div class="betModuleHeaderContainer">
                   <a class="betModuleHeaderBtn">
                     <span style="line-height: 32px;">${_t(
                       "Ndeshjet Kryesore"
                     )}</span>
                     <span class="yellowColored"></span>
                   </a>
                   <a class="betHeaderEventBtn" href="#/inPlay">

                   </a>
                </div>
            </div>
            <div class="featuredPrematchWrapper" style=" ${
              location.host === "365ebet365.com" && "display: none;"
            }"">
                <div class="featuredPrematchSlider">
                    ${featuredPrematchView}
                </div>
            </div>
                <div class="betModule liveInModule accordionDisable">
                 <div class="betModuleHeaderContainer">
                   <a class="betModuleHeaderBtn">
                     <strong style="font-size: 21px"><span>${_t(
                       "NE KOHE"
                     )}</span>
                     <span class="yellowColored">${_t("REALE")}</span></strong>
                   </a>
                   <a class="betHeaderEventBtn" href="#/inPlay">
                     <span>${_t("Te Gjitha Ndeshjet >")}</span>
                   </a>
                 </div>
                 <div class="singleHeaderHolderLabel fourColumn">
                      <div class="singleHeaderLabel">${_t('Soccer')}</div>
                      <div class="singleHeaderLabel">1</div>
                      <div class="singleHeaderLabel">x</div>
                      <div class="singleHeaderLabel">2</div>
                    </div>
                 <div class="betModuleContentContainer">
                   <div class="betModuleSportAccordion moduleFirstColour soccerTab">
                     <div class="moduleSportAccordionContent">
                       <div class="moduleSportSingleAccordion">
                         <div class="moduleSportSingleLeague">
                           <div class="moduleSportSingleLeagueContent gameTableContent" id="getTopTenLiveGamesViewF">
                           </div>
                           <a class="view-all-row" href="#/inPlay">
                            <span>${_t("Shiko te gjitha ne kohe reale")}</span>
                            <span>${_t("Te gjitha ndeshjet")}</span>
                           </a>
                         </div>
                       </div>
                     </div>
                   </div>
                 </div>
               </div>
               <div class="gameTableHeader m-t-6">
                    <span class="gameTableHeaderTitle">${_t(
                      "Ndeshjet ne vijim"
                    )}</span>
                </div>
                <div class="singleHeaderHolderLabel fourColumn">
                      <div class="singleHeaderLabel">${_t('Soccer')}</div>
                      <div class="singleHeaderLabel">1</div>
                      <div class="singleHeaderLabel">x</div>
                      <div class="singleHeaderLabel">2</div>
                    </div>
                <div class="gameTableContent">
                     <div class="gameTableContent" id="getTopTenMatchGamesViewF">
                                             </div>
                </div>

                <div class="betModule liveInModule accordionDisable m-t-6" id="todayAccordion">
                <div class="betModuleHeaderContainer">
                  <a class="betModuleHeaderBtn">
                    <span class="highlightColored">${_t("Futboll")}</span>
                    <span>${_t("Ndeshjet Sot")}</span>
                    <span class="yellowColored"></span>
                  </a>
                  <svg class="arrowDownIcon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" width="451.847px" height="451.847px" viewBox="0 0 451.847 451.847" style="enable-background:new 0 0 451.847 451.847;" xml:space="preserve">
                    <g>
                      <path d="M225.923,354.706c-8.098,0-16.195-3.092-22.369-9.263L9.27,151.157c-12.359-12.359-12.359-32.397,0-44.751   c12.354-12.354,32.388-12.354,44.748,0l171.905,171.915l171.906-171.909c12.359-12.354,32.391-12.354,44.744,0   c12.365,12.354,12.365,32.392,0,44.751L248.292,345.449C242.115,351.621,234.018,354.706,225.923,354.706z"/>
                    </g>
                  </svg>
                </div>
              </div>
              <div class="featuredPrematchWrappers" id="todayAccordionContent">
                <div class="featuredPrematchSlider">
                  ${todayMatchesView}
                </div>
              </div>
    
              <div class="betModule liveInModule accordionDisable m-t-6" id="today2hAccordion">
                <div class="betModuleHeaderContainer">
                  <a class="betModuleHeaderBtn">
                    <span class="highlightColored">${_t("Futboll")}</span>
                    <span>${_t("Ndeshjet 2 orët e ardhshme")}</span>
                    <span class="yellowColored"></span>
                  </a>
                  <svg class="arrowDownIcon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" width="451.847px" height="451.847px" viewBox="0 0 451.847 451.847" style="enable-background:new 0 0 451.847 451.847;" xml:space="preserve">
                    <g>
                      <path d="M225.923,354.706c-8.098,0-16.195-3.092-22.369-9.263L9.27,151.157c-12.359-12.359-12.359-32.397,0-44.751   c12.354-12.354,32.388-12.354,44.748,0l171.905,171.915l171.906-171.909c12.359-12.354,32.391-12.354,44.744,0   c12.365,12.354,12.365,32.392,0,44.751L248.292,345.449C242.115,351.621,234.018,354.706,225.923,354.706z"/>
                    </g>
                  </svg>
                </div>
              </div>
              <div class="featuredPrematchWrappers" id="today2hAccordionContent">
                <div class="featuredPrematchSlider">
                  ${next2hMatchesView}
                </div>
              </div>
    
              <div class="betModule liveInModule accordionDisable m-t-6" id="today4hAccordion">
                <div class="betModuleHeaderContainer">
                  <a class="betModuleHeaderBtn">
                    <span class="highlightColored">${_t("Futboll")}</span>
                    <span>${_t("Ndeshjet 4 orët e ardhshme")}</span>
                    <span class="yellowColored"></span>
                  </a>
                  <svg class="arrowDownIcon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" width="451.847px" height="451.847px" viewBox="0 0 451.847 451.847" style="enable-background:new 0 0 451.847 451.847;" xml:space="preserve">
                    <g>
                      <path d="M225.923,354.706c-8.098,0-16.195-3.092-22.369-9.263L9.27,151.157c-12.359-12.359-12.359-32.397,0-44.751   c12.354-12.354,32.388-12.354,44.748,0l171.905,171.915l171.906-171.909c12.359-12.354,32.391-12.354,44.744,0   c12.365,12.354,12.365,32.392,0,44.751L248.292,345.449C242.115,351.621,234.018,354.706,225.923,354.706z"/>
                    </g>
                  </svg>
                </div>
              </div>
              <div class="featuredPrematchWrappers" id="today4hAccordionContent">
                <div class="featuredPrematchSlider">
                  ${next4hMatchesView}
                </div>
              </div>
                <div class="betModule liveInModule m-t-6 accordionDisable">
                     <div class="betModuleHeaderContainer makeFull">
                       <a class="betModuleHeaderBtn">
                         <span>${_t("Kampionatet kryesore")}</span>
                         <span class="yellowColored"></span>
                       </a>
                     </div>
                </div>
                <div class="leagueHeaderContent" id="leagueHeaderContentF">
                </div>
            </div>
       `;

    return view;
  },
  after_render: async (socket) => {
    $("body").on("click", ".sliderItemCasino", async function (e) {
      const event = new CustomEvent("loadLiveCasino", {});
      window.dispatchEvent(event);
    });

    $("body").on("click", "#todayAccordion", function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      const show = $("body #todayAccordionContent").hasClass("show");
      toggleAccordion("#todayAccordion", show);
    });

    $("body").on("click", "#today2hAccordion", function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      const show = $("body #today2hAccordionContent").hasClass("show");
      toggleAccordion("#today2hAccordion", show);
    });

    $("body").on("click", "#today4hAccordion", function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      const show = $("body #today4hAccordionContent").hasClass("show");
      toggleAccordion("#today4hAccordion", show);
    });

    socket.emit("connectToRoom", { room: "prematch-games" });
    socket.emit("connectToRoom", { room: "inplay" });
    $("body .menuItem a").removeClass("active");
    $("body .mainLeftMenuItem a").removeClass("active");
    $("body #inPlayPage").removeClass("active");
    $("body .leftMenuHome ").addClass("active");
    $("body .homeLeftBtn").addClass("active");
    $("body .betModuleTabs").css({
      width: $(".betModuleTabs .betModuleTabsBtn a").length * 66 + "px",
    });
    $("body .featuredPrematchWrapper").each(function () {
      let featuredSliderWidth = 0;
      $(this)
        .children(".featuredPrematchSlider")
        .children(".featuredPrematchItem")
        .each(function () {
          featuredSliderWidth += $(this).outerWidth() + 2;
        });
      $(this)
        .children(".featuredPrematchSlider")
        .css({
          width: featuredSliderWidth - 3 + "px",
        });
    });

    toggleAccordion("#todayAccordion", !localStorage.getItem("today"));
    localStorage.removeItem("today");
  },
  on_unload: async (socket) => {
    socket.emit("leaveRoom", { room: "prematch-games" });
    socket.emit("leaveRoom", { room: "inplay" });
    timers.forEach((timer) => clearInterval(timer.timerId));
  },
};

function toggleAccordion(selecor, show) {
  if (show) {
    $(selecor).removeClass("rotate");
    $(`${selecor}Content`).removeClass("show");
    $(`${selecor}Content`).css({
      height: 0 + "px",
    });
  } else {
    let getHeight = $(
      `${selecor}Content .featuredPrematchSlider`
    ).outerHeight();
    $(selecor).addClass("rotate");
    $(`${selecor}Content`).addClass("show");
    $(`${selecor}Content`).css({
      height: getHeight + "px",
    });
  }
}

function liveTimer(id) {
  const current_minute = $(`#${id}`).text();
  if (!current_minute || current_minute == "" || current_minute == "45:00")
    return;
  let minutes = parseInt(current_minute.split(":")[0]);
  let seconds = parseInt(current_minute.split(":")[1]);

  if (seconds == 59) {
    minutes += 1;
    seconds = 0;
  } else seconds += 1;

  $(`#${id}`).text(
    `${minutes < 10 ? `0${minutes}` : minutes}:${
      seconds < 10 ? `0${seconds}` : seconds
    }`
  );
}

export default Landing;
